import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export const USERS_ROUTING_PARAMS = {
  tabName: 'tabName',
  userId: 'userId',
};

export class UsersPaths {
  static users = new EnhancedPath('/users');

  static userTab = new EnhancedPath(
    `${UsersPaths.users.path}/:${USERS_ROUTING_PARAMS.userId}/:${USERS_ROUTING_PARAMS.tabName}?`,
  );
}

const routesConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: UsersPaths.userTab.path,
      component: lazyWithRetry(() => import('app/pages/system/users/user')),
    },
    {
      path: UsersPaths.users.path,
      component: lazyWithRetry(() => import('app/pages/system/users')),
      pageCode: PAGE_CODES.USERS,
    },
  ],
};

export default routesConfig;
